export default function PHP_ob_get_flush() {
  return (
    <div>
      <h1>PHP_ob_get_flush</h1>
    </div>
  );
}
